/**
 * This component renders the standings tab for the game centre
 * WARNING - Currently using dummy data
 */
import React from "react";
import Standings from "../core/Standings";
import {allSeasons} from "../utils/time";

const GameCentreStandings = (offset) => {

  return (
    <Standings 
      type="all" 
      clubID={null}
      divisionID={null}
      sidebar={null}
      season_offset={offset.offset}
      seasons={allSeasons()}
    
    />
  );
}

export default GameCentreStandings;